import { Checkbox, Field } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let ResultsChartOptionsSection: React.FC<IWorksheetComponent> = () => (
  <ListFieldSection single>
    <Field input={<Checkbox />} name="Results.ChartOptions.JoinSpecificationPoints" />
  </ListFieldSection>
);

ResultsChartOptionsSection = withInjectedProps(ResultsChartOptionsSection);

export { ResultsChartOptionsSection };
export default ResultsChartOptionsSection;
